import useSWR from "swr"
import { InboundOrderApi } from "../../../apis"

// Backend `/ord/inbound-order/list` validates status + sourceType against
// these enums (Joi). A stale URL param from another page (e.g. delivery
// statuses like ASSIGNED) used to leak through and 400. Whitelist client-
// side so the request is always valid.
const VALID_STATUSES = new Set([
  "DRAFT",
  "APPROVED",
  "DISPATCHED_PICKUP",
  "PICKUP_COMPLETED",
  "IN_TRANSIT",
  "AT_DESTINATION",
  "RECEIVED",
  "CANCELLED",
])
const VALID_SOURCE_TYPES = new Set(["INTERNAL_WAREHOUSE", "EXTERNAL_PARTY"])

export function useInboundOrdersQuery({
  status,
  sourceType,
  page = 1,
  pageSize = 20,
}: {
  status?: string | null
  sourceType?: string | null
  page?: number
  pageSize?: number
}) {
  const safeStatus     = status && VALID_STATUSES.has(status) ? status : null
  const safeSourceType = sourceType && VALID_SOURCE_TYPES.has(sourceType) ? sourceType : null

  const cacheKey = ["inbound-orders", safeStatus ?? "ALL", safeSourceType ?? "ANY", page, pageSize] as const

  return useSWR(
    cacheKey,
    async () => {
      const filter: Record<string, unknown> = {}
      if (safeStatus) filter.status = safeStatus
      if (safeSourceType) filter.sourceType = safeSourceType
      return InboundOrderApi.list({
        filter,
        offset: { limit: pageSize, skip: (page - 1) * pageSize },
      })
    },
    { revalidateOnFocus: false, keepPreviousData: true },
  )
}
